import React from 'react';

import { useDogeWallet } from '@/networks/btc-like/doge';

import HeaderWalletDrawerDogeWalletConnect from './HeaderWalletDrawerDogeWalletConnect';
import HeaderWalletDrawerDogeWalletDetails from './HeaderWalletDrawerDogeWalletDetails/HeaderWalletDrawerDogeWalletDetails';

interface HeaderWalletDrawerDogeWalletProps {
  // Add any props you may need here
}

const HeaderWalletDrawerDogeWallet: React.FC<HeaderWalletDrawerDogeWalletProps> = () => {
  const { isConnected } = useDogeWallet();

  if (isConnected) {
    return <HeaderWalletDrawerDogeWalletDetails />;
  }

  return <HeaderWalletDrawerDogeWalletConnect className="h-14 w-full rounded-xl text-base" />;
};

export default HeaderWalletDrawerDogeWallet;
